import { PureComponent } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Loader, Segment, Button, Modal, Icon } from 'semantic-ui-react';

import { CustomSegment, CustomTooltip } from '../../../components';
import { filter, get, isEmpty, map, find } from '../../../utils/lodash';
import { putActivity } from '../../../store/actions';
import { getPageDisable, getActivityTypeToc } from '../../../utils';
import { ActivityParentGoalAndObjective } from './selectedGAndO';

import './activity.scss';

class ActivityParentTheoryCard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        projectTocKnown: props.currentActivity
          ? props.currentActivity.projectTocKnown
          : '',
        projectTocDo: props.currentActivity
          ? props.currentActivity.projectTocDo
          : '',
      },
      openPreviewModal: false,
    };
  }

  onChange(value, type) {
    let { form } = this.state;
    form[type] = value;
    this.setState({ form });
  }

  onBlurInput(type) {
    const { t, putActivity } = this.props;
    const { form } = this.state;

    try {
      putActivity('activityData', { [type]: form[type] });
    } catch (error) {
      NotificationManager.error(t('common.something_went_wrong'));
    }
  }

  openPreviewModal() {
    this.setState((prevState) => ({
      openPreviewModal: !prevState.openPreviewModal,
    }));
  }

  getWeWillText(defaultValues, currentActivity) {
    const { t } = this.props;
    let weWillText = '';
    if (isEmpty(defaultValues.projectTocDo)) {
      weWillText = (
        <span className="toc-knowing">
          {t(
            'activity.theory_of_change.describe_how_this_program_will_be_structured_to_achieve_the_objectives',
            { activityType: getActivityTypeToc(currentActivity) }
          )}
        </span>
      );
    } else {
      weWillText = defaultValues.projectTocDo;
    }
    return weWillText;
  }

  render() {
    let {
      currentActivity,
      user,
      helpTips,
      KnowingTipKey,
      weWillTipKey,
      currentState,
      extra,
      t,
    } = this.props;

    let objectives = [];
    if (extra.outcomes) {
      objectives = map(currentActivity.parentOutcomes, (outcome) => {
        outcome.main = find(extra.outcomes, (o) => {
          return o.id === outcome.outcomeId;
        });
        return outcome;
      });
    }

    const defaultValues = {
      projectTocKnown: currentActivity.projectTocKnown,
      projectTocDo: currentActivity.projectTocDo,
    };

    const secondaryDomains = map(
      filter(
        currentActivity.parentDomains,
        (i) => currentActivity.primaryPolicyId !== i.policy.id
      ),
      (d) => d.policy.policyName
    );
    // FIXME: once migrate all secondary domain from project to domain table this fallback need to be removed
    if (isEmpty(secondaryDomains)) {
      const secondaryPolicyName = get(
        currentActivity,
        'secondaryPolicy.policyName',
        null
      );
      if (secondaryPolicyName) secondaryDomains.push(secondaryPolicyName);
    }
    const primaryDomain = get(currentActivity, 'primaryPolicy.policyName', '');
    const domainNames = primaryDomain
      ? [primaryDomain, ...secondaryDomains]
      : secondaryDomains;

    const aimingStatement = !isEmpty(objectives) ? (
      <Trans
        i18nKey="activity.theory_of_change.we_are_aiming_for_outcomes_in_the_selected_domains"
        count={domainNames.length}
        values={{ domains: domainNames }}
      />
    ) : (
      <Trans i18nKey="activity.theory_of_change.we_are_aiming_for_outcomes_in_no_selected_domains" />
    );

    return (
      <>
        <Modal
          size="tiny"
          open={this.state.openPreviewModal}
          closeIcon={
            <Icon
              onClick={() => this.openPreviewModal()}
              name="close"
              className="closeicon"
            />
          }
        >
          <Modal.Header>
            <label className="modal-toc-preview-header">
              {t('common.theory_of_change')}
            </label>
          </Modal.Header>
          <Modal.Content>
            <div className="modal-toc-content">
              <p className="toc-line">{aimingStatement}</p>
              <p className="toc-line">
                <strong>{t('common.we_know_that')}</strong>{' '}
                {isEmpty(defaultValues.projectTocKnown) ? (
                  <span className="toc-knowing">
                    [{t('activity.theory_of_change.summarise_strongest_points')}
                    ]
                  </span>
                ) : (
                  defaultValues.projectTocKnown
                )}
              </p>
              <p className="toc-line">
                <strong>{t('common.therefore_we_will')}</strong>{' '}
                {this.getWeWillText(defaultValues, currentActivity)}
              </p>
            </div>
          </Modal.Content>
        </Modal>
        <AvForm className="activity-form" model={defaultValues}>
          <ActivityParentGoalAndObjective theory />
          <Segment className="content-segment" attached>
            <Grid>
              <Grid.Row>
                <Grid.Column mobile={16} tablet={16} computer={9}>
                  <div className="theory-textarea-container-grants">
                    <p className="toc-line">{aimingStatement}</p>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} tablet={16} computer={9}>
                  <div className="theory-textarea-container-grants">
                    <AvField
                      label={
                        <CustomTooltip
                          state={get(user, 'options.tips')}
                          contentObject={{
                            data: helpTips,
                            key: KnowingTipKey,
                          }}
                          position="top left"
                          wide="very"
                        >
                          <div>
                            <strong>{t('common.we_know_that')}</strong>
                          </div>
                        </CustomTooltip>
                      }
                      className="theory-textarea"
                      placeholder={t(
                        'activity.theory_of_change.summarise_strongest_points'
                      )}
                      name="projectTocKnown"
                      type="textarea"
                      onChange={(e) =>
                        this.onChange(e.target.value, 'projectTocKnown')
                      }
                      onBlur={() => this.onBlurInput('projectTocKnown')}
                      disabled={getPageDisable(
                        currentActivity,
                        user,
                        currentState
                      )}
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} tablet={16} computer={9}>
                  <div className="theory-textarea-container-grants">
                    <AvField
                      label={
                        <CustomTooltip
                          state={get(user, 'options.tips')}
                          contentObject={{
                            data: helpTips,
                            key: weWillTipKey,
                          }}
                          position="top left"
                          wide="very"
                        >
                          <strong>{t('common.therefore_we_will')}</strong>
                        </CustomTooltip>
                      }
                      className="theory-textarea"
                      name="projectTocDo"
                      type="textarea"
                      placeholder={`${t('activity.theory_of_change.describe_how_this_program_will_be_structured_to_achieve_the_objectives', { activityType: getActivityTypeToc(currentActivity) })}`}
                      onChange={(e) =>
                        this.onChange(e.target.value, 'projectTocDo')
                      }
                      onBlur={() => this.onBlurInput('projectTocDo')}
                      disabled={getPageDisable(
                        currentActivity,
                        user,
                        currentState
                      )}
                    />
                  </div>
                </Grid.Column>
                <Grid.Column
                  className="theory-textarea-container-single"
                  mobile={8}
                  tablet={8}
                  computer={8}
                >
                  <div className="preview-toc-button">
                    <Button
                      className="Primary-Button"
                      type="button"
                      onClick={() => this.openPreviewModal()}
                    >
                      {t('activity.theory_of_change.preview_theory_of_change')}
                    </Button>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </AvForm>
      </>
    );
  }
}

class ActivityParentTheory extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    return (
      <CustomSegment
        className="create-theory-of-change"
        title={`${t('activity.theory_of_change.create_theory_of_change')} - ${
          this.props.currentActivity.goal.split('-')[0]
        }`}
        children={
          <ActivityParentTheoryCard
            theory="One"
            KnowingTipKey="105"
            weWillTipKey="106"
            currentState="project.edit.theoryOfChange"
            {...this.props}
          />
        }
        rightHeader={
          <Loader
            active={
              this.props.actPut.theoryOne ? this.props.actPut.theoryOne : false
            }
            inline
          />
        }
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    extra: state.extra,
    user: state.authentication.user,
    helpTips: state.extra.activityHelpTips,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      putActivity,
    },
    dispatch
  );
};

ActivityParentTheory = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ActivityParentTheory));

export { ActivityParentTheory };
